import { transformAssets } from './assetsTransformer';

/** @param {string} imageUrl */
const getScaleImageUrl = (imageUrl = '') => imageUrl.replace(/t_main1|PLACEHOLDER/, 't_gig_cards_web');

/**
 * @param {import('./GigInfoPropType').assets} assets
 * @param {import('./GigInfoPropType').attachments} attachments
 * @returns {string}
 */
export const getImagePreview = (assets = [], attachments = []) => {
    const imageUrlsData = transformAssets({ assets, attachments });
    return getScaleImageUrl(imageUrlsData[0].cloudBaseUrl);
};

// README: This is a constant ID for sub-categories, based on sub-category copies json.
const OTHER_SUB_CATEGORY_IDS = [9, 20, 31, 38, 97, 117, 118, 120, 121, 122, 123, 137, 240, 457];

/** @type {(data: Partial<Record<'subCategoryId'|'nestedSubCategoryId', string|number>>) => string|undefined} */
export const getCategoryKey = ({ categoryId, subCategoryId, nestedSubCategoryId, replaceOther = true }) => {
    const categoryKey = `categories.category_${categoryId}`;
    const categoryNameKey = categoryId ? `${categoryKey}.name` : undefined;
    const subCategoryKey = `sub_categories.sub_category_${subCategoryId}`;
    const nestedSubCategoryNameKey = `${subCategoryKey}.nested_sub_cat_${nestedSubCategoryId}.name`;
    if (subCategoryId && nestedSubCategoryId) {
        return nestedSubCategoryNameKey;
    }
    if (subCategoryId) {
        let subCategoryNameKey = `${subCategoryKey}.name`;

        if (replaceOther && OTHER_SUB_CATEGORY_IDS.includes(Number(subCategoryId))) {
            subCategoryNameKey = categoryId ? categoryNameKey : subCategoryNameKey;
        }

        return subCategoryNameKey;
    }
    return categoryNameKey;
};
